<div class="h-full">
  <router-outlet />
  <shared-core-toast-container />
</div>
